import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
app.initializers.add('mr-subtitle', () => {
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const post = this.attrs.post;
    const user = post && post.user && post.user();
    if (!user) return;
    const subtitle = user.attribute('masqueradeSubtitle');
    const hasSubtitle = subtitle && subtitle.trim() !== '';
    if (hasSubtitle) {
      items.add('mr-subtitle', m("span", {
        className: "mr-subtitle"
      }, subtitle));
    }
    setTimeout(() => {
      const postEl = this.element.closest('.Post');
      if (!postEl) return;
      postEl.querySelectorAll('.item-autoCountBadgeOn').forEach(el => {
        el.style.setProperty('top', hasSubtitle ? '145px' : '125.5px', 'important');
      });
    });
  });
});